// src/components/modal/ModalHeader.tsx

import { ReactNode, useContext } from 'react';
import { ModalContext } from './ModalContext.ts';

interface ModalHeaderProps {
  children?: ReactNode;
  closeButton?: boolean;
  className?: string;
  closeButtonClassName?: string;
}

function ModalHeader({
  children,
  closeButton = true,
  className = '',
  closeButtonClassName = '',
}: ModalHeaderProps) {
  const { onClose } = useContext(ModalContext);

  return (
    <div
      className={`
        flex items-center justify-between
        border-b px-5 py-4
        ${className}
      `}
    >
      <div>{children}</div>

      {closeButton && (
        <button
          onClick={onClose}
          className={`${closeButtonClassName ? closeButtonClassName : "text-2xl leading-none opacity-70 ha:opacity-100"}`}
        >
          <svg className="w-5 h-5 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default ModalHeader;